import React, { Component, Fragment } from 'react';
import { CloseModal } from 'modules/common/styles/main';
import Icon from './Icon';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

const MyWrapper = styled.div`
.import-trigger-dialog-classname{
  .modal-content{
    height: 90vh;
  }
  .modal-body{
    height: calc ( 100% - 70px );
  }
  .neodiv{
    display: flex;
    flex-direction: column;
    
  }
  .import-trigger-form-wrapper{
    height: calc( 100% - 113px );

  }
}
`;

const propTypes = {
  title: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  backdrop: PropTypes.bool,
  ignoreTrans: PropTypes.bool,
  dialogClassName: PropTypes.string,
  showHide: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,

};

const contextTypes = {
  __: PropTypes.func
};

class ModalTrigger extends Component {
  constructor(props) {
    super(props);
  }

  getChildContext() {
    return { closeModal: this.closeModal };
  }
  
  renderHeader = () => {
    const { __ } = this.context;
    if (this.props.hideHeader) {
      return (
        <CloseModal onClick={this.props.closeModal}>
          <Icon icon="times" />
        </CloseModal>
      );
    }

    const { title, ignoreTrans , closeModal } = this.props;
    return (
      <Modal.Header>
        <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
        <span onClick={()=>closeModal(false)} style={{ cursor: "pointer", color: '#010101', fontSize: '25px' }} className='material-symbols-outlined'>cancel</span>
      </Modal.Header>
    );
  };

  render() {
    const {
      trigger,
      children,
      size,
      dialogClassName,
      closeModal,
      openModal,
    } = this.props;
    
    const triggerComponent = React.cloneElement(trigger, {
      onClick: () => openModal()
    });

    return (
      <Fragment>
        {triggerComponent}
        {
          this.props.showHide &&
          <MyWrapper>
            <Modal
              dialogClassName={dialogClassName}
              bsSize={size}
              show={this.props.showHide}
              onHide={() => closeModal()}
              backdrop='true'
              className={dialogClassName}
            >
              {this.renderHeader()}
              <Modal.Body>{children}</Modal.Body>
            </Modal>
          </MyWrapper>
        }
      </Fragment>
    );
  }
}

ModalTrigger.propTypes = propTypes;
ModalTrigger.contextTypes = contextTypes;


export default ModalTrigger;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ModalTrigger.js